var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"}));
}

Close.defaultProps = {"viewBox":"0 0 1792 1792","width":"100%","height":"100%"};

module.exports = Close;

Close.default = Close;
